import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useSession from "../../hooks/useSession";
import Loader from "../shared/Loader/Loader";

function AdminAuth({ children }) {
  const [user, loading] = useSession();
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }
  const { role } = user;

  if (role !== "admin") {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}

export default AdminAuth;
